import videojs from 'expose-loader?videojs!video.js';

import 'webrtc-adapter';
import RecordRTC from 'recordrtc';

import 'imports-loader?this=>window!videojs-record/dist/videojs.record.js';


// wait till DOM is ready
document.addEventListener('DOMContentLoaded', function () {

  if (document.getElementById('video-js-record') != undefined) {
    window.RecordVideoHandler = new RecordVideoHandler('video-js-record');
  }
});

class RecordVideoHandler {

  constructor(elementId) {
    this.videoElement = document.getElementById(elementId);
    this._recordingAttempts = 0;
    this.init(elementId);
  }

  init(elementId) {

    const [width, height] = Array.from(this.getVideoSize());
    const maxVideoLength = this.videoElement.getAttribute('data-max-length') || 120

    const playerOptions = {
      controls: true,
      autoplay: false,
      fluid: false,
      loop: false,
      width: width,
      height: height,
      controlBar: {
        volumePanel: false
      },
      plugins: {
        // configure videojs-record plugin
        record: {
          audio: false,
          video: true,
          debug: true,
          maxLength: maxVideoLength
        }
      }
    };

    this.player = videojs(elementId, playerOptions, function () {
      // print version information at startup
      let msg = 'Using video.js ' + videojs.VERSION +
        ' with videojs-record ' + videojs.getPluginVersion('record') +
        ' and recordrtc ' + RecordRTC.version;
      videojs.log(msg);
    });

    // device is ready
    this.player.on('deviceReady', function () {
      console.log('device is ready!');
    });

    // user clicked the record button and started recording
    this.player.on('startRecord', function () {
      this._recordingAttempts += 1;
      console.log('started recording!' + window.RecordVideoHandler._recordingAttempts);
    });

    // user completed recording and stream is available
    this.player.on('finishRecord', function () {
      // the blob object contains the recorded data that
      // can be downloaded by the user, stored on server etc.
      console.log('finished recording: ', window.RecordVideoHandler.player.recordedData);
      document.getElementById('learning_journal_entry_recorded_video_name').innerText = window.RecordVideoHandler.videoName()
    });

    // error handler
    this.player.on('error', function (element, error) {
      console.error(error);
    });

    this.player.on('deviceError', function () {
      console.error(window.RecordVideoHandler.player.deviceErrorCode);
    });
  }

  videoName() {
    return this.player.recordedData.name;
  }

  videoBlob() {
    if(this.player.recordedData != undefined) {
      return new Blob([this.player.recordedData], {type: 'video/webm'});
    }else {
      return undefined
    }
  }

  getVideoSize() {
    const responsiveWidth = document.getElementById('video-record-block').offsetWidth;
    const responsiveHeight = parseInt((responsiveWidth / 4) * 3, 10);

    return [responsiveWidth, responsiveHeight];
  }

  player() {
    return this.player;
  }

  recordingAttempts() {
    return this._recordingAttempts;
  }

}
